import type { TenantCode, TenantTheme } from '@/theme/types';
import { sflTheme } from '@/theme/tenants/sfl';
import { xichengTheme } from '@/theme/tenants/xicheng';

/**
 * GET /tenants/{code}/theme — 白标主题（决策 Q5 a-lite）。
 *
 * M3-π：mock 端点；M4 真接口出来后切 apiGet。
 * 后端契约（提案）：
 *   GET  /api/v1/tenants/{code}/theme  → TenantTheme JSON
 *   PATCH /api/v1/tenants/{code}/theme → 部分字段覆盖
 */
const MOCK_REGISTRY: Record<string, TenantTheme> = {
  sfl: sflTheme,
  xicheng: xichengTheme,
};

export async function fetchTenantTheme(code: TenantCode): Promise<TenantTheme> {
  // TODO M4: 切真接口
  //   const raw = await apiGet(`/tenants/${code}/theme`);
  //   return parseOrWarn(tenantThemeSchema, raw, `GET /tenants/${code}/theme`);
  await new Promise((r) => setTimeout(r, 80));
  const found = MOCK_REGISTRY[code];
  if (!found) throw new Error(`unknown tenant: ${code}`);
  return found;
}
